import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "donut" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["stroke", "stroke-dasharray", "stroke-dashoffset"]
const _hoisted_4 = {
  class: "donut__total",
  x: "60",
  y: "56"
}
const _hoisted_5 = {
  class: "donut__unit",
  x: "60",
  y: "72"
}
const _hoisted_6 = { class: "donut__legend" }
const _hoisted_7 = { class: "donut__label" }
const _hoisted_8 = { class: "donut__value" }
const _hoisted_9 = { class: "donut__pct" }
const _hoisted_10 = {
  key: 1,
  class: "donut__row"
}
const _hoisted_11 = { class: "donut__label" }
const _hoisted_12 = { class: "donut__value" }
const _hoisted_13 = { class: "donut__pct" }

import { computed } from 'vue'

export interface DonutSlice {
  label: string
  value: number
  color: string
  /** 클릭 시 이동할 경로(쿼리 포함) */
  to?: string
}

const R = 48
const THICK = 16

export default /*@__PURE__*/_defineComponent({
  __name: 'SellerDonutChart',
  props: {
    slices: {},
    centerLabel: { default: '건' },
    ariaLabel: { default: '구성 비율 그래프' }
  },
  setup(__props: any) {

const props = __props

const CIRC = 2 * Math.PI * R

const total = computed(() => props.slices.reduce((sum, slice) => sum + slice.value, 0))

const arcs = computed(() => {
  let offset = 0
  const sum = total.value || 1

  return props.slices.map((slice) => {
    const length = (slice.value / sum) * CIRC
    const arc = {
      ...slice,
      length,
      offset,
      percent: Math.round((slice.value / sum) * 100),
    }
    offset += length
    return arc
  })
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      class: "donut__svg",
      viewBox: "0 0 120 120",
      role: "img",
      "aria-label": __props.ariaLabel
    }, [
      _createElementVNode("circle", {
        class: "donut__track",
        cx: "60",
        cy: "60",
        r: R,
        "stroke-width": THICK
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arcs.value, (arc) => {
        return (_openBlock(), _createElementBlock("circle", {
          key: arc.label,
          class: "donut__arc",
          cx: "60",
          cy: "60",
          r: R,
          stroke: arc.color,
          "stroke-width": THICK,
          "stroke-dasharray": `${arc.length} ${CIRC}`,
          "stroke-dashoffset": -arc.offset,
          transform: "rotate(-90 60 60)"
        }, [
          _createElementVNode("title", null, _toDisplayString(arc.label) + " " + _toDisplayString(arc.value) + "건", 1)
        ], 8, _hoisted_3))
      }), 128)),
      _createElementVNode("text", _hoisted_4, _toDisplayString(total.value.toLocaleString('ko-KR')), 1),
      _createElementVNode("text", _hoisted_5, _toDisplayString(__props.centerLabel), 1)
    ], 8, _hoisted_2)),
    _createElementVNode("ul", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arcs.value, (arc) => {
        return (_openBlock(), _createElementBlock("li", {
          key: `lg-${arc.label}`
        }, [
          (arc.to)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: arc.to,
                class: "donut__row is-link"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: "donut__swatch",
                    style: _normalizeStyle({ background: arc.color })
                  }, null, 4),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(arc.label), 1),
                  _createElementVNode("strong", _hoisted_8, _toDisplayString(arc.value.toLocaleString('ko-KR')), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(arc.percent) + "%", 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", {
                  class: "donut__swatch",
                  style: _normalizeStyle({ background: arc.color })
                }, null, 4),
                _createElementVNode("span", _hoisted_11, _toDisplayString(arc.label), 1),
                _createElementVNode("strong", _hoisted_12, _toDisplayString(arc.value.toLocaleString('ko-KR')), 1),
                _createElementVNode("span", _hoisted_13, _toDisplayString(arc.percent) + "%", 1)
              ]))
        ]))
      }), 128))
    ])
  ]))
}
}

})